//
import { required } from '@/services/validations'
import ProductModel from '@/models/Warehouse/WhProduct'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'
import DispatchRequestDetailHeaders from './headers'
import DispatchRequestDetailHeadersOriginal from './headersOriginal'

//
const default_fields = ({ g_branch_office_id }) =>
    [
        {
            title: 'nuevo',
            fields: [
                {
                    name: 'g_seller_user_full_name',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Vendedor',
                        readonly: true,
                    },
                },
                {
                    name: 'pos_sale_pos_payment_types_str',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Tipo de pago',
                        readonly: true,
                    },
                },
                {
                    name: 'created_at',
                    type: 'date-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Creado',
                        pickerProps: {
                            readonly: true,
                        },
                    },
                },
                {
                    name: 'g_state_name',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Estado',
                        readonly: true,
                    },
                },
                {
                    name: 'pos_detail_sales_edited',
                    type: 'table-field',
                    flex: {
                        'pt-0': true,
                        xs12: true,
                    },
                    props: {
                        checkable: true,
                        class: 'v-card elevation-2 mb-4',
                        headers: DispatchRequestDetailHeaders,
                        noActions: true,
                        noDataText: 'Sin productos.',
                        noFilter: true,
                        noExport: true,
                        noHelper: true,
                        noPagination: true,
                        noSearch: true,
                        label: 'Items',
                        pickerProps: {
                            filters: ProductFilters({}),
                            headers: ProductHeaders,
                            noPagination: false,
                            mapper: row => {
                                row['g_branch_office_id'] = g_branch_office_id
                                row['discount_amount'] = 0
                                row['discount_percentage'] = 0
                                return row
                            },
                            submitText: 'confirmar selección',
                            service: ProductModel,
                            title: 'Seleccionar producto',
                        },
                        showNativePagination: true,
                        showPicker: true,
                        style: {
                            //margin: "0 -24px"
                        },
                        toolbarTitle:
                            'Lista de productos incluidos en el ticket de venta',
                        toolbarColor: 'primary',
                        toolbarDark: true,
                        toolbarDense: true,
                        rules: [required],
                    },
                    trigger(ctx) {
                        
                    },
                },
                /*{
                    name: '_',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {},
                },*/
                // {
                //     name: 'discount_or_charge_amount_edited',
                //     type: 'currency-field',
                //     flex: {
                //         sm6: true,
                //         lg3: true,
                //     },
                //     props: {
                //         label: 'Descuento',
                //         placeholder: '$',
                //     },
                // },
                {
                    name: 'discount_or_charge_percentage_edited',
                    type: 'float-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Descuento (%)',
                        reverse: true,
                    },
                    trigger(ctx) {/*
                        //
                        const { discount_or_charge_percentage_edited, invoice_subtotal_edited } = ctx.value
                        const new_subtotal = invoice_subtotal_edited * 1.19
                        const new_discount = discount_or_charge_percentage_edited / 100
                        //
                        ctx.value.invoice_total_edited = Math.max(Math.round(new_subtotal * ( 1 - new_discount )), 0)
                        //
                        console.log('olaaaaaaa', new_discount)*/
                        /*ctx.value.pos_detail_sales_edited.forEach(item => {
                            item.discountPercentageProduct = ctx.value.discount_or_charge_percentage_edited
                            item.discountValueProduct = item.discountPercentageProduct * item.priceProduct
                        })*/
                    },
                },
                {
                    name: 'invoice_subtotal_edited',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Subtotal',
                        reverse: true,
                        readonly: true,
                    },
                },
                {
                    name: 'invoice_iva_edited',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'IVA',
                        readonly: true,
                    },
                },
                {
                    name: 'invoice_total_edited',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Total',
                    },
                },
            ],
        },
        {
            title: 'original',
            fields: [
                {
                    name: 'g_seller_user_full_name',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Vendedor',
                        readonly: true,
                    },
                },
                {
                    name: 'pos_sale_pos_payment_types_str',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Tipo de pago',
                        readonly: true,
                    },
                },
                {
                    name: 'created_at',
                    type: 'date-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Creado',
                        pickerProps: {
                            readonly: true,
                        },
                    },
                },
                {
                    name: 'g_state_name',
                    type: 'text-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Estado',
                        readonly: true,
                    },
                },
                {
                    name: 'pos_detail_sales_original',
                    type: 'table-field',
                    flex: {
                        'pt-0': true,
                        xs12: true,
                    },
                    props: {
                        class: 'v-card elevation-2 mb-4',
                        headers: DispatchRequestDetailHeadersOriginal,
                        noActions: true,
                        noDataText: 'Sin productos.',
                        noFilter: true,
                        noExport: true,
                        noHelper: true,
                        noPagination: true,
                        noSearch: true,
                        label: 'Items',
                        showNativePagination: true,
                        toolbarTitle:
                            'Lista de productos incluidos en el ticket de venta',
                        toolbarColor: 'primary',
                        toolbarDark: true,
                        toolbarDense: true,
                        readonly: true,
                        rules: [required],
                    },
                },
                /*{
                    name: '_',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {},
                },*/
                // {
                //     name: 'discount_or_charge_amount',
                //     type: 'currency-field',
                //     flex: {
                //         sm6: true,
                //         lg3: true,
                //     },
                //     props: {
                //         label: 'Descuento',
                //         fieldProps: {
                //             readonly: true,
                //         },
                //     },
                // },
                {
                    name: 'discount_or_charge_percentage',
                    type: 'percentage-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Descuento',
                        fieldProps: {
                            readonly: true,
                        },
                    },
                },
                {
                    name: 'new_net_subtotal',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Subtotal',
                        readonly: true,
                    },
                },
                {
                    name: 'iva',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'IVA',
                        readonly: true,
                    },
                },
                {
                    name: 'invoice_total',
                    type: 'currency-field',
                    flex: {
                        sm6: true,
                        lg3: true,
                    },
                    props: {
                        label: 'Total',
                        readonly: true,
                    },
                },
            ],
        },
    ].reverse()

//
export default ({ g_branch_office_id, can_confirm, can_edit }) =>
    can_confirm || can_edit
        ? default_fields({ g_branch_office_id })
        : default_fields({ g_branch_office_id })[1]['fields']
